import PersonalityQuizParticipationQuestionModel from "./PersonalityQuizParticipationQuestionModel";
import PersonalityQuizPersonaPercentsModel from "./PersonalityQuizPersonaPercentsModel";

export default class PersonalityQuizParticipationModel {
  public personalityQuizId: string = null;
  public userId: string = null;
  public questions: PersonalityQuizParticipationQuestionModel[] = [];
  public personas: PersonalityQuizPersonaPercentsModel[] = [];
  public attempts: number = null;
}
